<template>
  <div>
    <v-row
      align="center"
      justify="center"
    >
      <v-col>
        <VTextField
          v-model="data.name[selectedLang]"
          :label="$t('forms.labels.name')"
          :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
          data-cy="network-text"
          outlined
          @input="updateData"
        />
        <VSelect
          v-model="data.key"
          outlined
          :label="$t('forms.labels.key')"
          :required="true"
          :items="keys"
          itemValue="value"
          itemText="value"
          data-cy="role"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import networkTypeKeys from '../../../../constants/networkTypeKeys';

export default {
    components: {
        VTextField,
        VSelect,
    },
    props: {
        networkType: {
            type: Object,
            default: () => ({}),
        },
        usedKeys: {
            type: Array,
            default: () => [],
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            data: {
                name: {},
                key: '',
            },
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamLangs',
            'teamMainLang',
            'selectedLang',
        ]),
        keys() {
            return Object.values(networkTypeKeys).map(nt => ({
                name: nt,
                value: nt,
                disabled: this.usedKeys.includes(nt),
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('sendData', this.data);
            },
            deep: true,
        },
    },
    async created() {
        if (this.isEdition) {
            this.data = this.networkType;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
